export enum EntityName {
  Dataset = 'Dataset',
  DatasetAccess = 'DatasetAccess',
  PbiDataset = 'PbiDataset',
  IdentityPrincipal = 'IdentityPrincipal',
  Group = 'GroupPrincipal',
  Organisation = 'OrganisationPrincipal',
  ReportInfo = 'ReportInfo',
  Report = 'Report',
  Role = 'Role',
  User = 'UserPrincipal',
  UserRole = 'UserRole',
  ReportActivityRecord = 'ReportActivityRecord',
  ReportActivityRecordInfo = 'ReportActivityRecordInfo',
  ReportUserPreference = 'ReportUserPreference',
  ReportAccess = 'ReportAccess',
  GroupMembership = 'GroupMembership',
  PbiReport = 'PbiReport',
  Bookmark = 'Bookmark',
  DraftBookmark = 'DraftBookmark',
  OrganisationMembership = 'OrganisationMembership',
  OrganisationWorkspace = 'OrganisationWorkspace',
  TemplateWorkspace = 'TemplateWorkspace',
  OrganisationWorkspaceInfo = 'OrganisationWorkspaceInfo',
  UserReportFilter = 'UserReportFilter',
  UserReportWorkspaceFilter = 'UserReportWorkspaceFilter',
  PbiDeployment = 'PbiDeployment',
  OrganisationWorkspaceDeployment = 'OrganisationWorkspaceDeployment'
}
